import * as yup from "yup";
import {
  fieldMustBeANumber,
  fieldMustBePositive,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";

// Which operation the transaction dialog performs. Determines the endpoint
// (topUp -> /Deposit/TopUp, withdraw -> /Deposit/Withdraw) and the labels.
export type DepositTransactionMode = "topUp" | "withdraw";

// The user always enters a POSITIVE amount — the API applies the sign per
// transaction type. The comment is mandatory (audit trail for money moves).
export const userDepositTransactionFormSchema = yup.object({
  amount: yup
    .number()
    .typeError(fieldMustBeANumber("Сума"))
    .positive(fieldMustBePositive("Сума"))
    .required(requiredField("Сума")),
  comment: yup.string().trim().required(requiredField("Коментар")),
});

export type IUserDepositTransactionFormModel = yup.InferType<
  typeof userDepositTransactionFormSchema
>;

export const userDepositTransactionFormDefaultValues: IUserDepositTransactionFormModel =
  {
    amount: undefined as unknown as number,
    comment: "",
  };
